

















import Vue, { PropType } from 'vue';
import { ButtonTypes, ButtonSizes } from './Button.types';
import LoadingIndicator from '../../../basic/LoadingIndicator.vue';

export default Vue.extend({
  name: 'Button',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<ButtonTypes>,
      default: 'normal',
    },
    nativeType: {
      type: String,
      default: 'button',
    },
    size: {
      type: String as PropType<ButtonSizes>,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    uppercase: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    LoadingIndicator,
  },
  computed: {
    classes() {
      return [
        `button-${this.type}`,
        this.size ? `button-${this.size}` : '',
        this.loading ? `button-loading` : '',
        this.rounded ? 'button-rounded' : '',
        this.uppercase ? 'button-uppercase' : '',
      ];
    },
  },
});
